(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chewsy-purchase-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('chewsy-purchase')) {
    customElements.define('chewsy-purchase', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const form = this.querySelector('.chewsy-purchase-form');
        const payload = this.querySelector('[data-purchase-data]');
        if (!form || !payload) return;
        let data;
        try { data = JSON.parse(payload.textContent); } catch { return; }
        const variantSelect = form.querySelector('[data-purchase-variant]');
        const identity = form.querySelector('[data-purchase-id]');
        const planSelect = form.querySelector('[data-purchase-plan]');
        const quantity = form.querySelector('[data-purchase-quantity]');
        const button = form.querySelector('[data-purchase-submit]');
        const price = form.querySelector('[data-purchase-price]');
        const compare = form.querySelector('[data-purchase-compare]');
        const description = form.querySelector('[data-purchase-plan-description]');
        const variantField = form.querySelector('[data-purchase-variant-field]');
        if (!identity || !quantity || !button || !price || !compare || !Array.isArray(data.variants)) return;
        const current = () => data.variants.find(variant => variant.id === identity.value);
        const refresh = () => {
          const variant = current();
          if (!variant) { button.disabled = true; return; }
          const plan = planSelect && variant.plans.find(item => item.id === planSelect.value);
          const valid = !variant.requiresSellingPlan || Boolean(plan);
          const selected = plan || variant;
          price.textContent = selected.priceLabel;
          compare.textContent = selected.compareLabel;
          compare.hidden = !(selected.comparePrice > selected.price);
          if (description) description.textContent = plan ? plan.description : '';
          button.disabled = !variant.available || !valid;
          button.textContent = !variant.available ? this.dataset.soldOutLabel : valid ? this.dataset.addLabel : this.dataset.choiceLabel;
        };
        if (variantSelect) {
          variantField.hidden = false;
          variantSelect.addEventListener('change', () => {
            const variant = data.variants.find(item => item.id === variantSelect.value);
            if (!variant) return;
            identity.value = variant.id;
            quantity.min = String(variant.minimum);
            quantity.step = String(variant.increment);
            if (variant.maximum) quantity.max = String(variant.maximum); else quantity.removeAttribute('max');
            quantity.value = String(variant.minimum);
            if (planSelect) {
              const previous = planSelect.value;
              planSelect.replaceChildren();
              const empty = new Option(variant.requiresSellingPlan ? this.dataset.choiceLabel : this.dataset.onceLabel + ' — ' + variant.priceLabel, '');
              empty.disabled = variant.requiresSellingPlan;
              for (const plan of variant.plans) planSelect.add(new Option(this.dataset.subscribeLabel + ' — ' + plan.priceLabel, plan.id));
              planSelect.add(empty);
              planSelect.value = variant.plans.some(plan => plan.id === previous) ? previous : (variant.plans.length ? variant.plans[0].id : '');
              planSelect.required = variant.requiresSellingPlan;
              planSelect.disabled = !variant.requiresSellingPlan && variant.plans.length === 0;
              form.querySelector('[data-purchase-plan-field]').hidden = planSelect.disabled;
            }
            refresh();
          });
        }
        if (planSelect) planSelect.addEventListener('change', refresh);
        refresh();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
